var _polygon, _polygon2, _rect, _rect2, _rect3, _g, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesStandardArc51(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "254.7px",
    height: "302px",
    viewBox: "0 0 254.7 302",
    enableBackground: "new 0 0 254.7 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.3508,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 24.4,27.5 24.5,21.2 3.9,21.2 9.5,27.5 24.4,27.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.3508,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 230.3,27.7 245.1,27.7 250.8,21.3 230.2,21.3 230.2,27.7 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.1,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 142.9,
    y: 60.8,
    fill: "#494848",
    width: 0,
    height: 40.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    d: "M23.5,221.5c0,0,0,2.6-0.4,3.7 c-0.7,1.8,0.5,2.3,0.5,2.3h207.8c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H23.5L23.5,221.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    d: "M23.5,216.2c0,0,0.1,1.9-0.4,3.7 c-1.1,2.3,0.5,2.3,0.5,2.3h207.8c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H23.5L23.5,216.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    d: "M26.1,10.6h205.5l-0.3,171.2 c0,0,0.1,1.1,0,4.3c0.5,1.9,1,30.4-0.5,30.4c-1.6,0-202.5,0-206.6,0c-2.9,0-0.9-28-1.2-33.9c0-1.4,0-172,0-172L26.1,10.6 L26.1,10.6z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    x1: 23,
    y1: 41.2,
    x2: 231.5,
    y2: 41.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    x1: 23,
    y1: 74.9,
    x2: 231.5,
    y2: 74.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    x1: 23,
    y1: 110.4,
    x2: 231.5,
    y2: 110.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    x1: 23,
    y1: 147.6,
    x2: 231.5,
    y2: 147.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0018,
    strokeMiterlimit: 10,
    x1: 23,
    y1: 184.3,
    x2: 231.5,
    y2: 184.3
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 0,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.362,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 246.9,
    height: 21.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesStandardArc51);
export default __webpack_public_path__ + "static/media/FeaturesStandard_arc51.21f85ee3a1b8e02f1896176984144726.svg";
export { ForwardRef as ReactComponent };